import { type FC, type ReactElement } from 'react';

import clsx from 'clsx';
import { ResponsiveContainer as ReResponsiveContainer } from 'recharts';

import { type WithClassName } from '@/types/react';

import styles from './ResponsiveContainer.module.scss';

type ResponsiveContainerProps = WithClassName & {
  children: ReactElement;
};

export const ResponsiveContainer: FC<ResponsiveContainerProps> = (props) => {
  const { className, children } = props;

  return (
    <div className={clsx(styles.root, className)}>
      <div className={styles.inner}>
        <ReResponsiveContainer minWidth={0} width="100%" minHeight={0} height="100%">
          {children}
        </ReResponsiveContainer>
      </div>
    </div>
  );
};
